export const fr_text: Record<string, string> = {
  "Sign in to your Lulu Loyal account to access all our features.":
    "Connectez-vous à votre compte Lulu Loyal pour accéder à toutes nos fonctionnalités.",
  "Don't have an account?": "Vous n'avez pas de compte ?",
  "Click here to create one.": "Cliquez ici pour en créer un.",
  "Create Lulu Loyal Account": "Créer un compte Lulu Loyal",
  "Log In To Lulu Loyal": "Se connecter à Lulu Loyal",
  "Forgot Password?": "Mot de passe oublié ?",
  "Delete Account": "Supprimer le compte",
  "Confirm Delete": "Confirmer la suppression",
  "Are you sure you want to delete your account? This action cannot be undone and will cancel any active subscriptions.":
    "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action ne peut pas être annulée et annulera tout abonnement actif.",
  "Delete Permanently": "Supprimer définitivement",
  "Confirm Logout": "Confirmer la déconnexion",
  "Are you sure you want to logout?":
    "Êtes-vous sûr de vouloir vous déconnecter ?",
  "Password Recovery": "Récupération du mot de passe",
  "Enter your email address to receive a login link.":
    "Entrez votre adresse e-mail pour recevoir un lien de connexion.",
  "Send Recovery Email": "Envoyer l'e-mail de récupération",
  "Recovery email sent. Please check your inbox.":
    "E-mail de récupération envoyé. Veuillez vérifier votre boîte de réception.",
  "Account updated successfully.": "Compte mis à jour avec succès.",
  "How Lulu Works": "Comment fonctionne Lulu",
  "100% untraceable": "100% intraçable",
  "Just share the username": "Partagez simplement le nom d'utilisateur",
  "No Login Required": "Aucune connexion requise",
  "Invalid login link": "Lien de connexion invalide",
  "Signing you in...": "Connexion en cours...",
  Loading: "Chargement",
  "Analyzing {username}": "Analyse de {username}",
  seconds: "secondes",
  "Figuring out who they follow": "Découverte de qui ils suivent",
  "Looking at who follows them": "Regardant qui les suit",
  "Figuring out who's new": "Découvrant qui est nouveau",
  "Looking for suspicious profiles": "Recherche de profils suspects",
  "Taking a closer look": "Examen de plus près",
  "Looking through off-site content": "Examen du contenu externe",
  "Analyzing behavior patterns": "Analyse des modèles de comportement",
  "Checking for red flags": "Vérification des signaux d'alarme",
  "Wrapping up (this can take a while)":
    "Finalisation (cela peut prendre du temps)",
  "Finding stories": "Recherche d'histoires",
  "Loading story content": "Chargement du contenu des histoires",
  "Processing media": "Traitement des médias",
  "Preparing anonymous view": "Préparation de la vue anonyme",
  Finalizing: "Finalisation",
  "Email Address": "Adresse email",
  Save: "Enregistrer",
  "@username": "@nomutilisateur",
  "Reveal Follows": "Révéler les abonnements",
  "Anonymously View Stories": "Voir les stories anonymement",
  "find red flags": "trouver des signaux d'alarme",
  "Best Results": "Meilleurs résultats",
  "Search over a billion accounts":
    "Rechercher parmi plus d'un milliard de comptes",
  "Is this legal?": "Est-ce légal ?",
  "Lulu Loyal": "Lulu Loyal",
  LINKS: "LIENS",
  "Why Use Lulu Loyal?": "Pourquoi utiliser Lulu Loyal ?",
  Prices: "Prix",
  Resources: "Ressources",
  LEGAL: "LÉGAL",
  "Privacy Policy": "Politique de confidentialité",
  "Terms of Use": "Conditions d'utilisation",
  "Refund Policy": "Politique de remboursement",
  "CONTACT US": "NOUS CONTACTER",
  "support@lululoyal.com": "support@lululoyal.com",
  "© 2025 Lulu Loyal. All Rights Reserved.":
    "© 2025 Lulu Loyal. Tous droits réservés.",
  "Manage Account": "Gérer le compte",
  Login: "Connexion",
  Anonymity: "Anonymat",
  "Secure + Untraceable": "Sécurisé + Intraçable",
  "Security Risks": "Risques de sécurité",
  Pricing: "Tarification",
  "Lowest Prices": "Prix les plus bas",
  "Pretends to Be Free": "Prétend être gratuit",
  Speed: "Vitesse",
  "Fastest + Best Results": "Plus rapide + Meilleurs résultats",
  "Slow + Poor Results": "Lent + Mauvais résultats",
  Quality: "Qualité",
  "Unmatched Accuracy": "Précision inégalée",
  "Consistent Errors": "Erreurs constantes",
  Features: "Fonctionnalités",
  "Best Features": "Meilleures fonctionnalités",
  "Limited Features": "Fonctionnalités limitées",
  "Insta/TikTok/Snap": "Insta/TikTok/Snap",
  "All 3": "Les 3",
  "Only Instagram": "Instagram seulement",
  "Everyone Else": "Tous les autres",
  "🌶️ Porn account": "🌶️ Compte porno",
  "🍒 Baddie": "🍒 Fille canon",
  "🍑 Spicy content": "🍑 Contenu épicé",
  "No Red Flags": "Aucun signal d'alarme",
  "Follows back": "Suit en retour",
  "No follow back": "Ne suit pas en retour",
  "Subscribe to reveal all": "Abonnez-vous pour tout révéler",
  "{number} new girls": "{number} nouvelles filles",
  "{number} new guys": "{number} nouveaux mecs",
  "{number} Others": "{number} autres",
  "Subscribe to Reveal All": "S'abonner pour tout révéler",
  "{number} RED FLAGS": "{number} SIGNAUX D'ALARME",
  "{number} SUS PROFILES": "{number} PROFILS SUSPECTS",
  "Updated {hours}h ago": "Mis à jour il y a {hours}h",
  "This account is private": "Ce compte est privé",
  "Notify Me": "Me notifier",
  "Reveal More": "Révéler plus",
  "UPDATED {hours} HOURS AGO": "MIS À JOUR IL Y A {hours} HEURES",
  "Stories from @{username}": "Stories de @{username}",
  "Refresh Stories": "Actualiser les stories",
  "{number} STORIES": "{number} STORIES",
  "ANONYMOUS VIEWING": "VISUALISATION ANONYME",
  "Subscribe to view": "S'abonner pour voir",
  "User Not Found": "Utilisateur non trouvé",
  "Try Again": "Réessayer",
  "Results for": "Abonnements les plus récents de :",
  "+{number} more": "+{number} de plus",
  "View All Recent Followers": "Voir tous les abonnés récents",
  "See Who They Followed": "Voir qui ils ont suivi",
  "Recent Follows": "Abonnements Récents",
  "Recent Followers": "Abonnés Récents",
  "Thank You!": "Merci !",
  "Your subscription is now active.": "Votre abonnement est maintenant actif.",
  "You now have full access to all Lulu Loyal features.":
    "Vous avez maintenant un accès complet à toutes les fonctionnalités de Lulu Loyal.",
  "Start Analyzing": "Commencer l'Analyse",
  "Create a Lulu Loyal account to access all our features.":
    "Créez un compte Lulu Loyal pour accéder à toutes nos fonctionnalités.",
  "If you have an account, ": "Si vous avez un compte, ",
  "you can login by clicking here.":
    "vous pouvez vous connecter en cliquant ici.",
  "My Account": "Mon Compte",
  "Change Email Address": "Changer l'Adresse Email",
  "Change Password": "Changer le Mot de Passe",
  "Manage Subscription": "Gérer l'Abonnement",
  "You are already subscribed": "Vous êtes déjà abonné",
  "Account not found": "Compte non trouvé",
  "View All": "Voir Tout",
  Girls: "Filles",
  Guys: "Garçons",
  Other: "Autre",
  All: "Tous",
  "Lulu Loyal's FAQ": "FAQ de Lulu Loyal",
  "PER WEEK": "PAR SEMAINE",
  "Stop guessing, learn the truth, and reduce your anxiety levels with Lulu Loyal's tools.":
    "Arrêtez de deviner, apprenez la vérité et réduisez vos niveaux d'anxiété avec les outils de Lulu Loyal.",
  "Unlimited access to all tools.": "Accès illimité à tous les outils.",
  "No commitment, cancel any time.": "Sans engagement, annulez à tout moment.",
  "Free relationship anxiety guide.":
    "Guide gratuit sur l'anxiété relationnelle.",
  "Get Unlimited Access": "Obtenir un accès illimité",
  "User Reviews": "Avis Utilisateurs",
  "Step 1 - Enter a Username": "Étape 1 - Entrez un nom d'utilisateur",
  "Enter a username to start the search.":
    "Entrez un nom d'utilisateur pour commencer la recherche.",
  "Step 2 - Anonymous Search": "Étape 2 - Recherche Anonyme",
  "Do an untraceable, anonymous search.":
    "Effectuez une recherche anonyme et intraçable.",
  "Step 3 - Best Results": "Étape 3 - Meilleurs Résultats",
  "Receive the best results, learn the truth.":
    "Recevez les meilleurs résultats, apprenez la vérité.",
  "Instantly saw who my boyfriend had just followed! Got rid of soo much anxiety!":
    "J'ai vu instantanément qui mon copain venait de suivre ! Je me suis débarrassée de tellement d'anxiété !",
  "- Sophie": "- Sophie",
  "My ex was following Onlyfan models... like 4 of them 😭😭😭 At least I left him in time 🥲":
    "Mon ex suivait des modèles OnlyFans... genre 4 d'entre elles 😭😭😭 Au moins je l'ai quitté à temps 🥲",
  "- Osheb": "- Osheb",
  "I noticed my SO was following a bunch of new accounts very day... turns out it was nothing, good to check.":
    "J'ai remarqué que mon partenaire suivait plein de nouveaux comptes chaque jour... finalement ce n'était rien, c'était bien de vérifier.",
  "- Anonymous": "- Anonyme",
  "Most recent follow": "Abonnement le plus récent",
  "Loyalty analysis": "Analyse de fidélité",
  "Can I trust these results?": "Puis-je faire confiance à ces résultats ?",
  "Yes, our tech is best in class, and it's designed to be as accurate as possible. If you can't get the results you're looking for here, you can't get them anywhere. Our tech is the most advanced.":
    "Oui, notre technologie est la meilleure de sa catégorie et elle est conçue pour être aussi précise que possible. Si vous ne pouvez pas obtenir les résultats que vous recherchez ici, vous ne les obtiendrez nulle part. Notre technologie est la plus avancée.",
  "Is this 100% anonymous?": "Est-ce 100% anonyme ?",
  "Yes, there's no way anyone could ever know, or see that you've searched for a person. They'll also never know you've searched for them either. We've made that our top priority.":
    "Oui, il n'y a aucun moyen que quelqu'un puisse savoir ou voir que vous avez recherché une personne. Ils ne sauront jamais non plus que vous les avez recherchés. Nous en avons fait notre priorité absolue.",
  "Can I catch cheaters with this?":
    "Puis-je attraper des tricheurs avec cela ?",
  "Yes, many people have, and many people have stopped themselves landing in heartbreak. You can use Lulu Loyal to make sure you're not interacting with people who will mess you around.":
    "Oui, beaucoup de gens l'ont fait, et beaucoup de gens ont évité d'avoir le cœur brisé. Vous pouvez utiliser Lulu Loyal pour vous assurer de ne pas interagir avec des personnes qui vous feront du mal.",
  "All the data we gather is public and it's 100% legal to collect this data, and to interact with this data too. You're not doing anything which breaks any law anywhere by searching for someone.":
    "Toutes les données que nous collectons sont publiques et il est 100% légal de collecter ces données et d'interagir avec elles également. Vous ne faites rien qui enfreint une loi où que ce soit en recherchant quelqu'un.",
  "Why should I trust Lulu Loyal?":
    "Pourquoi devrais-je faire confiance à Lulu Loyal ?",
  "Because we've been in your shoes, which is exactly why we built this product. What matters most to us, is to help other people find good people that won't mess them around.":
    "Parce que nous avons été à votre place, et c'est exactement pourquoi nous avons créé ce produit. Ce qui compte le plus pour nous, c'est d'aider d'autres personnes à trouver de bonnes personnes qui ne leur feront pas de mal.",
  "Unlimited Searches": "Recherches Illimitées",
  "Completely Anonymous": "Complètement Anonyme",
  "No Commitment. Cancel Anytime.": "Sans Engagement. Annulez à Tout Moment.",
  "Easy to Cancel": "Facile à Annuler",
  "Secured by Stripe Payments": "Sécurisé par Stripe Payments",
};
